import { Action } from '@amarkets/atlas/esm/lib/action';
import { TwoFactorStatus } from '../entities/two-factor-status';
import { StatusMapper } from '../mappers/2fa-status-mapper';
import {
  MUTATION_SET_2FA_STATUS,
  MUTATION_SET_IS_LOADING_STATUS,
} from '../types';

export class Get2faStatus extends Action {
  _api;

  constructor({ twoFactorApi, errorHandler }) {
    super();
    this._api = twoFactorApi;
    this._errorHandler = errorHandler;
  }

  async execute({ commit }) {
    await Get2faStatus._withLoading(async () => {
      try {
        const statusMapper = new StatusMapper((opts) => new TwoFactorStatus(opts));
        const status = await this._api.get2faStatus((data) => statusMapper.mapStatus(data));

        commit(MUTATION_SET_2FA_STATUS, status);
      } catch (e) {
        this._errorHandler.handle(e, 'while execute Get2faStatus');
      }
    }, commit, MUTATION_SET_IS_LOADING_STATUS);
  }
}
